import { resourceAccommodationDefinitionZodObject } from "@@/shared/acquire/resources/resource-definition";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const resourceAccommodationDefinitionEditCommandResponseZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_ACCOMMODATION_DEFINITION_EDIT_COMMAND_RESPONSE"),
    _createdAt: isoAndUnixZodSchema,
    definition: resourceAccommodationDefinitionZodObject,
});
type ResourceAccommodationDefinitionEditCommandResponse = z.infer<
    typeof resourceAccommodationDefinitionEditCommandResponseZodObject
>;

const resourceAccommodationDefinitionEditCommandResponseFactoryParamsZodObject =
    resourceAccommodationDefinitionEditCommandResponseZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof resourceAccommodationDefinitionEditCommandResponseFactoryParamsZodObject
>;

const resourceAccommodationDefinitionEditCommandResponseFactory = (
    params: FactoryParams,
) => {
    const resourceAccommodationDefinitionEditCommandResponse: ResourceAccommodationDefinitionEditCommandResponse =
        {
            ...params,
            _id: generateId({
                prefix: "resource_accommodation_definition_edit_command_response__",
            }),
            _type: "RESOURCE_ACCOMMODATION_DEFINITION_EDIT_COMMAND_RESPONSE",
            _createdAt: nowIsoAndUnix(),
        };
    return resourceAccommodationDefinitionEditCommandResponse;
};

export {
    resourceAccommodationDefinitionEditCommandResponseFactory,
    resourceAccommodationDefinitionEditCommandResponseFactoryParamsZodObject,
    resourceAccommodationDefinitionEditCommandResponseZodObject,
};
export type {
    ResourceAccommodationDefinitionEditCommandResponse,
    FactoryParams as ResourceAccommodationDefinitionEditCommandResponseFactoryParams,
};
